export const SocialPlayerTikTokViewerType = 'wixui.SocialPlayerTikTok' as const;

export const TestIds = {
  viewer: {
    iframe: 'SocialPlayerTikTok-iframe',
  },
};
